import { useState, useEffect, useCallback } from "react";
import Event from "../services/event";

export const useFetchMaterialsData = (queryParams) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchMaterials = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const materialsList = await Event.listMaterials();

            if (!materialsList || !materialsList.data?.data) {
                throw new Error("Failed to load data");
            }

            setData(materialsList.data.data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchMaterials();
    }, [fetchMaterials, queryParams]);

    return { data, loading, error, refetch: fetchMaterials };
};
